// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"index-module_checkbox_FPoyr","checked":"index-module_checked_3nDqo"};